import { Select, type SelectOption } from '@/shared/ui/select'

interface InlineSelectProps {
  value: string
  options: SelectOption[]
  onSave: (value: string) => void
  ariaLabel: string
  className?: string
  placeholder?: string
  disabled?: boolean
}

// «Тихий инлайн»-выбор: значение выглядит обычным текстом, клик → лёгкое
// popover-меню (Select variant="inline"), выбор → PATCH через onSave.
export function InlineSelect({
  value,
  options,
  onSave,
  ariaLabel,
  className,
  placeholder,
  disabled,
}: InlineSelectProps) {
  return (
    <Select
      variant="inline"
      aria-label={ariaLabel}
      value={value}
      onChange={onSave}
      options={options}
      {...(disabled ? { disabled: true } : {})}
      {...(placeholder ? { placeholder } : {})}
      {...(className ? { className } : {})}
    />
  )
}
